/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLaptopPhone: {
  name: 'laptop-phone';
  data: string;
} = {
  name: 'laptop-phone',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3a1 1 0 1 1-2 0V5H5v10h7a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2V5ZM2 20a1 1 0 0 1 1-1h9a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1Zm14-10a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2h-4Zm0 2h4v7h-4v-7Z" fill="currentColor"/></svg>`,
};
